import { render, staticRenderFns } from "./historical-order.vue?vue&type=template&id=04c1e7ce&scoped=true&lang=pug"
import script from "./historical-order.vue?vue&type=script&lang=js"
export * from "./historical-order.vue?vue&type=script&lang=js"
import style0 from "./historical-order.vue?vue&type=style&index=0&id=04c1e7ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1e7ce",
  null
  
)

export default component.exports